import urlParse from 'url-parse';

const STATUS = {
    TRIAL: 1,
    EXPIRED_TRIAL: 2,
    CONTINUATION_RECEPTION: 3,
    CONTINUATION: 4,
    CANCELLATION_RECEPTION: 5,
    CANCELLATION: 6
};

/**
 * 共通で使えるメソッドを定義するミックスインオブジェクト
 */
export default {
    data () {
        return {
            config: {},
            // D&D時の掴んだバナーindex番号
            move_index: null,
        };
    },
    computed: {
        // adminユーザーフラグ
        isAdmin: function () {
            if (typeof this.config.user !== 'undefined' && this.config.user.is_admin) {
                return true;
            }
            return false;
        },
        // ogariaユーザーフラグ
        isOgariaUser: function () {
            if (typeof this.config.user_contract !== 'undefined' && this.config.user_contract.is_ogaria_user) {
                return true;
            }
            return false;
        },
        isOpening: function () {
            if (typeof this.config.user.opening !== 'undefined' && this.config.user.opening) {
                return true;
            }
            return false;
        },
        // 現状のステータス
        status () {
            if (typeof this.config.user_contract === 'undefined') {
                return null;
            }
            return this.config.user_contract.status;
        },
        // トライアル中か否か
        isStatusTrial () {
            return this.status === STATUS.TRIAL || this.status === STATUS.EXPIRED_TRIAL;
        },
    },
    /**
     * インスタンス生成時に実行される処理
     */
    created() {
        this.$_setConfig();
    },
    /**
     * 各種メソッド
     */
    methods: {
        /**
         * グローバルヘッダの表示切り替え(jQueryで非表示に)
         */
        $_showGlobalHeader (bool = true) {
            const $target = $('.global-header');
            if (bool) {
                $target.removeClass('d-none');
            } else {
                $target.addClass('d-none');
            }
        },
        /**
         * JSで使う用にレンダリングされたJSON文字列をデータとして取得
         */
        $_setConfig () {
            const data = document.querySelector('[data-roll="config"]');
            if (data && data.innerHTML) {
                this.config = JSON.parse(data.innerHTML);
            }
        },
        /**
         * objectか判定
         */
        $_isObject (value) {
            const toString = Object.prototype.toString;
            return (toString.call(value).slice(8, -1).toLowerCase() === 'object');
        },
        /**
         * ブラウザ判定。キーを返す
         * (いつか使えなくなる可能性あり)
         */
        $_browser () {
            const ua = window.navigator.userAgent.toLowerCase();
            if (ua.indexOf('msie') != -1 || ua.indexOf('trident') != -1) {
                return 'ie';
            }
            if (ua.indexOf('edg') != -1) {
                return 'edge';
            }
            if (ua.indexOf('chrome') != -1) {
                return 'chrome';
            }
            if (ua.indexOf('safari') != -1) {
                return 'safari';
            }
            if (ua.indexOf('firefox') != -1) {
                return 'firefox';
            }
            if (ua.indexOf('opera') != -1) {
                return 'opera';
            }
            return null;
        },
        /**
         * chromeを使っているか
         */
        $_useChrome () {
            return this.$_browser() === 'chrome';
        },
        /**
         * ローディングスピナーを全面に表示する
         */
        $_loading () {
            document.querySelector('[data-roll="overlay_loader"]').classList.add('active');
            document.querySelector('[data-roll="overlay_loader"]').classList.remove('hidden');
        },
        /**
         * 全面に表示しているローディングスピナーを非表示にする
         */
        $_unloading () {
            document.querySelector('[data-roll="overlay_loader"]').classList.add('hidden');
            document.querySelector('[data-roll="overlay_loader"]').classList.remove('active');
        },
        /**
         * 並び替え用でキーを生成
         */
        $_createKey: function (data, index) {
            return JSON.stringify(data) + index + moment().unix() + Math.random();
        },
        /**
         * 配列の要素を指定位置に移動
         * D&D後のdata入れ替えなどに使う
         *
         * @param array 配列データ
         * @param index 指定要素index番号
         * @param at 移動先index番号
         * @returns array
         */
        $_moveAt: function (array, index, at) {
            if (index === at || index > array.length - 1 || at > array.length - 1) {
                return array;
            }
            const value = array[index];
            const tail = array.slice(index + 1);
            array.splice(index);
            Array.prototype.push.apply(array, tail);
            array.splice(at, 0, value);
            return _.cloneDeep(array);
        },
        /**
         * async/awaitを使ってsleep()を実現
         */
        $_sleep: function sleep(msec) {
            return new Promise(function(resolve) {
                setTimeout(function() {
                    resolve();
                }, msec);
            });
        },
        /**
         * URLパラメータを配列で返す
         * @returns array
         */
        $_params: function(key = null) {
            const params = new urlParse(window.location.href, true).query;
            if (!key) {
                return params;
            }
            if (typeof params[key] !== 'undefined') {
                return params[key];
            }
            return null;
        },
        /**
         * copyID取得(build_store、item、custom_pageで利用想定)
         * URLパラメータにcopyキーがあった時、idキーの値を返す
         * @returns array
         */
        $_copyId: function() {
            const params = this.$_params();
            if (typeof params['copy'] !== 'undefined' && typeof params['id'] !== 'undefined') {
                return params['id'];
            }
            return null;
        },
        /**
         * 指定単位でbyte数を返す
         * @param bytes
         * @param k
         * @param decimals
         * @returns string
         */
        $_formatBytes: function(bytes, k = 1024, decimals = 2) {
            if (bytes === 0) return '0 Bytes';

            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        },
        /**
         * HTML文字列をエスケープする
         * @param value
         * @returns string
         */
        $_htmlEscape: function(value) {
            if (!value) {
                return '';
            }
            return value.replace(/[<>&"'`]/g, (match) => {
                const escape = {
                    '<': '&lt;',
                    '>': '&gt;',
                    '&': '&amp;',
                    '"': '&quot;',
                    '\'': '&#39;',
                    '`': '&#x60;'
                };
                return escape[match];
            });
        },
        /**
         * アンエスケープする
         * @param value
         * @returns string
         */
        $_unEscape: function(value) {
            if (!value) {
                return '';
            }
            const escape = {
                '&lt;'   : '<',
                '&gt;'   : '>',
                '&amp;'  : '&',
                '&quot;' : '"',
                '&#x27;' : '\'',
                '&#x60;' : '`'
            };
            let unescaped = value.replace(/&(lt|gt|amp|quot|#x27|#x60);/g, function(match) {
                return escape[match];
            });
            return unescaped;
        },
        /**
         * 改行コードを<br>タグに変換する
         * @param value
         * @returns string
         */
        $_convertToBrTag: function(value) {
            return value.replace(/\r/g, '').replace(/\n/g, '<br>');
        },
        /**
         * 値が通常配列でなければ(値か連想配列だったら)配列にする
         *
         * 'key' => '値'
         * ↓
         * 'key' => ['値']
         *
         * @param value
         * @returns array
         */
        $_changeArray: function(value) {
            if (Object.prototype.toString.call(value) === '[object Object]') {
                return [value];
            }
            return value;
        },
        /**
         * ヤフーのページURLを構築
         * @param pageKey
         * @returns string
         */
        $_yahooPageUrl: function(pageKey) {
            return 'https://store.shopping.yahoo.co.jp/' + this.config.user.shop_id + '/' + pageKey + '.html';
        },
    }
};
